import React, { Component } from 'react';
import { Dropdown, Divider, Segment, Form, Label } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import _ from 'lodash';
import months from '../../../utils/months';
import {
  getPageWithPageToken,
  getPageBackedInstagramAccounts
} from '../../../fbApi/Page';
import { getAccount } from '../../../fbApi/Account';
import {
  getCampaignWithPromotedObjects,
  getCampaignsWithoutAdsets
} from '../../../fbApi/Campaign';
import { getProductSets } from '../../../fbApi/ProductCatalog';

// to do: possibly reuse this in ad launch
class AdLibraryLaunchDestinationFields extends Component {
  onSelectPage = async (event, { value, options }) => {
    const { stateFromParent } = this.props;
    const form = stateFromParent.form;

    const selectedPage = _.find(options, (opt) => {
      return opt.value === value;
    });

    const { value: selectedPageValue } = selectedPage || {};
    const { pageId, access_token: accessToken } = selectedPageValue;

    const pageResult = await getPageWithPageToken(pageId, accessToken);
    const { instagram_accounts: instagramAccounts } = pageResult || {};
    const { data: instagramAccountsData } = instagramAccounts || {};

    if (instagramAccountsData) {
      const instagramAccoutToUse = instagramAccounts[0];
      form.instagramAccount = instagramAccoutToUse
        ? instagramAccoutToUse.id
        : '';
    } else {
      const instagramResult = await getPageBackedInstagramAccounts(
        pageId,
        accessToken
      );
      const { data: instagramData } = instagramResult || {};
      if (instagramData && instagramData[0]) {
        form.instagramAccount = instagramData[0].id;
      }
    }

    form.pageId = pageId;
    form.pageAccessToken = accessToken;

    this.setStateInParent({
      form,
      selectedPage: selectedPageValue
    });
  };

  handleFormInputChange = (event, { name, value }) => {
    const { stateFromParent } = this.props;
    const form = stateFromParent.form;
    form[name] = value;

    this.setFormState(form);
  };

  onAccountSelect = async (event, data) => {
    const { stateFromParent, getFbToken } = this.props;
    const { form } = stateFromParent;
    const token = getFbToken();
    const account = _.find(data.options, (option) => {
      return option.value === data.value;
    });
    const accountId = account.value;
    form.accountId = accountId;
    form.accountName = account.text;
    form.adsets = [];

    this.setStateInParent(
      {
        showYearLoader: true,
        showAdsetsSelector: false,
        showMonthSelector: false,
        showYearSelector: false,
        data: null,
        years: [],
        campaign_ids: [],
        filteredCampaigns: [],
        selectedCampaigns: '',
        selectedYear: '',
        selectedMonth: ''
      },
      async () => {
        await this.getCampaigns(accountId, token);
        const accountData = await getAccount(accountId, token);
        if (
          accountData &&
          accountData.adspixels &&
          accountData.adspixels.data[0]
        ) {
          form.pixel = accountData.adspixels.data[0].id;
        } else {
          form.pixel = '';
        }
        this.setFormState(form);
      }
    );
  };

  getCampaigns = async (id, token) => {
    try {
      const campaigns = await getCampaignsWithoutAdsets(id, token);
      const result = campaigns.data;

      const assocCampaigns = [];
      const campaignMonths = [];
      const years = [];

      _.map(_.reverse(_.sortBy([...result], 'start_time')), (campaign) => {
        const firstPart = campaign.name.split('_')[0];
        const year =
          firstPart.length === 4
            ? firstPart
            : firstPart.substring(firstPart.length - 4, firstPart.length);
        const month =
          firstPart.length === 4
            ? campaign.name.split('_')[1]
            : firstPart.substring(0, firstPart.length - 4);
        assocCampaigns[year + month] = {
          month_year: null,
          ids: [],
          campaigns: []
        };
      });

      _.map(
        _.reverse(_.sortBy([...result], 'start_time')),
        async (campaign) => {
          const firstPart = campaign.name.split('_')[0];
          const year =
            firstPart.length === 4
              ? firstPart
              : firstPart.substring(firstPart.length - 4, firstPart.length);
          const month =
            firstPart.length === 4
              ? campaign.name.split('_')[1]
              : firstPart.substring(0, firstPart.length - 4);

          const existentYear = years.filter((item) => item.text === year);

          if (existentYear.length === 0) {
            years.push({
              value: year,
              text: year
            });
          }

          assocCampaigns[year + month].month = month;
          assocCampaigns[year + month].year = year;
          assocCampaigns[year + month].ids.push(campaign.id);
          assocCampaigns[year + month].campaigns.push({
            id: campaign.id,
            name: campaign.name,
            objective: campaign.objective
          });
        }
      );

      _.mapKeys(assocCampaigns, (assocCampaign) => {
        if (assocCampaign) {
          campaignMonths.push(assocCampaign);
        }
      });

      const campaignOpts = _.map(campaignMonths, (op, index) => {
        const month = months.filter((item) => item.shortName === op.month);

        return {
          key: index,
          value: op.ids.join(','),
          text: month[0] ? month[0].monthName : op.month,
          accountId: id,
          campaigns: op.campaigns,
          year: op.year
        };
      });

      this.setStateInParent({
        data: result,
        campaigns: campaignOpts,
        filteredCampaigns: campaignOpts,
        showYearSelector: true,
        showYearLoader: false,
        years
      });
    } catch (error) {
      console.log(error);
    }
  };

  onYearSelect = (event, { value }) => {
    const { stateFromParent } = this.props;
    const filteredCampaigns = stateFromParent.campaigns.filter(
      (val) => val.year === value
    );

    this.setStateInParent({
      showAdsetsSelector: false,
      showMonthSelector: true,
      showMonthLoader: false,
      filteredCampaigns,
      selectedCampaigns: '',
      selectedYear: value,
      selectedMonth: ''
    });
  };

  setFormState = (formToUse) => {
    const parameters = { form: formToUse };
    this.setStateInParent(parameters);
  };

  setStateInParent = (parameters, callback = null) => {
    const { setStateInParent } = this.props;
    if (setStateInParent) {
      setStateInParent(parameters, callback);
    }
  };

  onMonthSelect = (event, { value, options }) => {
    const { stateFromParent } = this.props;
    this.setStateInParent(
      {
        showAdsetLoader: true,
        showAdsetsSelector: false,
        form: { ...stateFromParent.form, adsets: [] }
      },
      async () => {
        const selectedCampaignMonth = _.find(
          options,
          (option) => option.value === value
        );
        const ids = selectedCampaignMonth.value.split(',');
        const monthInYear = selectedCampaignMonth.text;
        const month = months.find((item) => item.monthName === monthInYear);
        const { monthNumber, monthName } = month || {};
        const selectedMonth = monthNumber || new Date().getMonth() + 1;
        const selectedCampaignMonthWithAdsets = await this.getAdSetsForCampaignMonth(
          monthName || selectedCampaignMonth.text
        );
        const { campaigns } = selectedCampaignMonthWithAdsets || {};

        if (!campaigns || campaigns.length <= 0) {
          toast.warn(
            `There are no adsets to load for the selected campaign month.`,
            {
              position: 'bottom-left',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true
            }
          );
          this.setStateInParent({
            showAdsetLoader: false,
            showAdsetsSelector: true,
            selectedMonth
          });
        } else {
          const newForm = { ...stateFromParent.form };

          const initialAdsetsForForm = campaigns.map((campaign) => ({
            campaignId: campaign.id,
            adsets: [],
            adsetsData: campaign.adsets
          }));
          newForm.adsets = initialAdsetsForForm;

          this.setStateInParent({
            showAdsetLoader: false,
            showAdsetsSelector: true,
            selectedMonth,
            campaign_ids: campaigns || [],
            selectedCampaigns: ids.join(','),
            form: newForm
          });
        }
      }
    );
  };

  getAdSetsForCampaignMonth = async (selectedMonthName) => {
    try {
      if (selectedMonthName.trim() === '') throw Error('Select a month name.');
      const { stateFromParent, getFbToken } = this.props;
      const { filteredCampaigns } = stateFromParent;
      const token = getFbToken();
      const campaignMonthToUse = filteredCampaigns.find((campaign) => {
        const { text: monthName } = campaign;
        return monthName === selectedMonthName;
      });
      const { campaigns } = campaignMonthToUse || {};
      const campaignIds =
        campaigns && campaigns.length > 0
          ? campaigns.map((campaign) => {
              const { id } = campaign;
              return id;
            })
          : [];

      const campaignsWithAdsets =
        campaignIds.length > 0
          ? await Promise.all(
              campaignIds.map(async (id) => {
                const getCampaignResult = await getCampaignWithPromotedObjects(
                  id,
                  token
                );
                return getCampaignResult;
              })
            )
          : [];

      const filteredCampaignsWithAdsets = campaignsWithAdsets.filter(
        (campaign) => {
          const { adsets } = campaign || {};
          const { data: adsetData } = adsets || [];
          return adsetData && adsetData.length > 0;
        }
      );
      const campaignsWithMappedAdsets = filteredCampaignsWithAdsets.map(
        (campaignWithAdsets) => {
          const { adsets } = campaignWithAdsets || {};
          const shallowCampaignCopy = campaignWithAdsets;
          const { data: adsetData } = adsets || [];
          const mappedAdsetForDropdown =
            adsetData && adsetData.length > 0
              ? _.map(adsetData, (adsetObject, index) => {
                  const {
                    id,
                    name,
                    promoted_object: promotedObject,
                    ads
                  } = adsetObject;
                  return {
                    key: index,
                    value: id,
                    text: name,
                    promotedObject,
                    ads: ads && ads.data ? ads.data : []
                  };
                })
              : [];
          shallowCampaignCopy.adsets = mappedAdsetForDropdown;
          return shallowCampaignCopy;
        }
      );
      campaignMonthToUse.campaigns = campaignsWithMappedAdsets || [];

      return campaignMonthToUse;
    } catch (error) {
      toast.warn(
        `Something went wrong. Select the month again or refresh the page`,
        {
          position: 'bottom-left',
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true
        }
      );
      console.log(
        'Something went wrong in getAdSetsForCampaignMonth():',
        error
      );
      return [];
    }
  };

  onProductCatalogSelection = async (event, { value }) => {
    const { stateFromParent, getFbToken } = this.props;
    const { form } = stateFromParent;

    if (!value) {
      this.setStateInParent({
        form: { ...form, productCatalog: '', productSet: '' },
        productSets: []
      });
      return;
    }
    try {
      const token = await getFbToken();
      const result = await getProductSets(token, value);
      const productSets = result ? result.data : [];
      const productSetSelectionList = productSets.map((productSet, index) => ({
        key: index,
        text: productSet.name,
        value: productSet.id
      }));

      this.setStateInParent({
        form: { ...form, productCatalog: value },
        productSets: productSetSelectionList
      });
    } catch (error) {
      toast.error(`An error occurred while setting the product set: ${error}`);
    }
  };

  render() {
    const {
      stateFromParent,
      productCatalogs,
      launchIncludesCollectionAds
    } = this.props;
    const {
      pages,
      form,
      accounts,
      selectedPage,
      years,
      selectedYear,
      selectedCampaigns,
      filteredCampaigns,
      showYearSelector,
      showYearLoader,
      showMonthSelector,
      showMonthLoader,
      showAdsetLoader,
      showAdsetsSelector,
      campaign_ids: campaignIds,
      loadingPages
    } = stateFromParent;
    return (
      <Segment basic textAlign="center">
        <Dropdown
          fluid
          placeholder="Account"
          search
          selection
          value={form.accountId}
          options={accounts}
          onChange={this.onAccountSelect}
        />
        <Divider hidden />
        {showYearSelector ? (
          <Dropdown
            fluid
            placeholder="Year"
            search
            selection
            value={selectedYear}
            options={years}
            onChange={this.onYearSelect}
          />
        ) : (
          <div>{showYearLoader ? <span>Loading years...</span> : null} </div>
        )}
        <Divider hidden />
        {showMonthSelector ? (
          <Dropdown
            fluid
            placeholder="Month"
            search
            selection
            options={filteredCampaigns}
            value={selectedCampaigns}
            onChange={this.onMonthSelect}
          />
        ) : (
          <div>{showMonthLoader ? <span>Loading months...</span> : null} </div>
        )}
        <Divider hidden />
        {showAdsetLoader ? (
          <span>Loading adsets...</span>
        ) : (
          <div>
            {showAdsetsSelector ? (
              <div>
                {campaignIds && campaignIds.length > 0 ? (
                  <Label
                    basic
                    color="green"
                    icon="checkmark"
                    content="Adsets have been loaded"
                  />
                ) : (
                  <Label
                    basic
                    color="red"
                    icon="close"
                    content="Adsets could not be retrieved"
                  />
                )}
              </div>
            ) : null}
          </div>
        )}
        <Divider />
        <Dropdown
          fluid
          placeholder="Pages"
          search
          selection
          disabled={loadingPages}
          loading={loadingPages}
          options={pages}
          value={selectedPage}
          onChange={this.onSelectPage}
        />
        <Divider hidden />
        <Form.Input
          fluid
          placeholder="Display Url"
          type="text"
          name="displayUrl"
          value={form.displayUrl}
          onChange={this.handleFormInputChange}
        />
        {launchIncludesCollectionAds && (
          <div>
            <Divider hidden />
            <Dropdown
              placeholder="Product Catalog"
              style={{ width: '100%' }}
              search
              selection
              clearable
              name="productCatalog"
              options={productCatalogs}
              value={form.productCatalog}
              onChange={this.onProductCatalogSelection}
            />
          </div>
        )}
      </Segment>
    );
  }
}

export default AdLibraryLaunchDestinationFields;



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/AdLibrary/AdLibraryLaunchDestinationFields.jsx